export default __webpack_public_path__ + "assets/images/button-close.ca1ed26232d733fc76d538708eaa52c8.svg";